import React from 'react';
import { usePromiseTracker } from "react-promise-tracker";
import "./spinner.css";

export const Spinner = (props) => {
    
    const { promiseInProgress } = usePromiseTracker();

    return (
        promiseInProgress && (
            <div className="spinner text-center overlay-Modal" data-backdrop="static" data-keyboard="false">
                <div className="spinner-border text-primary" role="status"></div>
            </div>
        )
    );
};